import { useT } from "@transifex/react";
import BasePopupWrapper, { TitleColorVariants } from "../../basic/popups/BasePopupWrapper";

interface PreviewBlockedPopupProps {
    isOpen: boolean;
    onClose: () => void;
}

const PreviewBlockedPopup = (props: PreviewBlockedPopupProps) => {
    const t = useT();

    const t_title = t("Preview mode", { _tags: "ClassMemberDashboard, PreviewBlockedPopup" });
    const t_description = t("Activities cannot be started in preview mode.", {
        _tags: "ClassMemberDashboard, PreviewBlockedPopup",
    });
    const t_gotIt = t("Got it!", { _tags: "ClassMemberDashboard, PreviewBlockedPopup" });

    return (
        <BasePopupWrapper
            isOpen={props.isOpen}
            onClose={props.onClose}
            title={t_title}
            titleColor={TitleColorVariants.DEFAULT}
            primaryButton={{
                text: t_gotIt,
                onClick: props.onClose,
            }}
        >
            <p className="text-l text-p6-grey-dark">{t_description}</p>
        </BasePopupWrapper>
    );
};

export default PreviewBlockedPopup;
